export const SET_REQUISICOES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.requisicoes.data = payload
    state.requisicoes.lastUpdate = new Date()
  }
}

export const SET_REQUISICOES_LOADING = (state, payload) => {
  state.requisicoes.loading = payload
}

export const UPDATE_REQUISICAO = (state, payload) => {
  if (payload && payload.id) {
    const index = state.requisicoes.data.findIndex(
      (item) => item.id === payload.id
    )
    if (index !== -1) {
      state.requisicoes.data.splice(index, 1, {
        ...state.requisicoes.data[index],
        ...payload,
      })
    }
  }
}

export const SET_ACTIVE_POLLING = (state, { requestId, intervalId }) => {
  state.activePolling = { ...state.activePolling, [requestId]: intervalId }
}

export const REMOVE_ACTIVE_POLLING = (state, requestId) => {
  const copy = { ...state.activePolling }
  delete copy[requestId]
  state.activePolling = copy
}
